import { reviewList } from "@/mocks/erogeData";

export default function Reviews() {
  return (
    <section id="reviews" className="py-14 md:py-20 px-4 md:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="mb-10">
          <span className="inline-flex items-center gap-1.5 text-accent-500 text-sm mb-2">
            <i className="ri-edit-2-line" />
            REVIEWS
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 tracking-wide">
            工口游戏口碑评测
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl leading-7">
            不吹不黑，只讲真实体验。每篇评测都涵盖剧情、美术、音乐与可玩性，附优缺点分析，帮你做出更理性的选择。
          </p>
        </div>

        <div className="flex flex-col gap-6 md:gap-8">
          {reviewList.map((r) => (
            <article
              key={r.id}
              className="group flex flex-col lg:flex-row gap-5 md:gap-6 rounded-xl bg-background-100/50 border border-background-200/60 p-4 md:p-5 hover:border-secondary-500/40 transition-colors cursor-pointer"
            >
              <div className="lg:w-80 xl:w-96 shrink-0">
                <div className="relative w-full h-48 lg:h-full min-h-44 rounded-lg overflow-hidden">
                  <img
                    src={r.cover}
                    alt={`${r.title} 工口游戏评测封面图`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>

              <div className="flex-1 flex flex-col">
                <div className="flex items-center justify-between gap-3 mb-2">
                  <span className="text-xs text-foreground-500">{r.meta}</span>
                  <span className="text-xs text-foreground-500">{r.date}</span>
                </div>
                <h3 className="font-heading text-lg md:text-xl text-foreground-950 mb-2">{r.title}</h3>
                <p className="text-sm text-foreground-600 leading-7">{r.summary}</p>

                <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div className="rounded-lg bg-background-200/50 p-3">
                    <p className="flex items-center gap-1.5 text-xs text-secondary-400 mb-2">
                      <i className="ri-thumb-up-line" /> 优点
                    </p>
                    <ul className="space-y-1">
                      {r.pros.map((p) => (
                        <li key={p} className="text-xs text-foreground-600 flex items-start gap-1.5">
                          <i className="ri-checkbox-circle-line text-secondary-500 text-[11px] mt-0.5" />
                          {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="rounded-lg bg-background-200/50 p-3">
                    <p className="flex items-center gap-1.5 text-xs text-foreground-500 mb-2">
                      <i className="ri-thumb-down-line" /> 不足
                    </p>
                    <ul className="space-y-1">
                      {r.cons.map((c) => (
                        <li key={c} className="text-xs text-foreground-600 flex items-start gap-1.5">
                          <i className="ri-subtract-line text-foreground-500 text-[11px] mt-0.5" />
                          {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="mt-4 flex items-center justify-between">
                  <div className="flex items-baseline gap-1">
                    <span className="font-heading text-3xl md:text-4xl text-accent-400">{r.score}</span>
                    <span className="text-xs text-foreground-500">/ 10</span>
                  </div>
                  <span className="inline-flex items-center gap-2 text-sm text-primary-500 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                    阅读完整评测 <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}